export { ColorBoxVariant, default as ColorBox } from './color-box'
